import { defineStore } from 'pinia'
import { TShortPage } from '~/types/page-types'

type TStoreState = {
    slugId: string | undefined,
    visible: boolean | false,
    card: string | undefined,
    classes: string | undefined,
    dimensions: {
        translateX?: string,
        translateY?: string,
        width?: string,
        height?: string,
    },
    shorts: TShortPage[]
};

export const useShortsStore = defineStore('shorts', {
  state: (): TStoreState => {
    return {
      slugId: undefined,
      visible: false,
      card: undefined,
      classes: undefined,
      dimensions: {},
      shorts: []
    }
  },
  actions: {
    clear () {
      this.$state.slugId = undefined
      this.$state.visible = false
      this.$state.card = ''
      this.$state.classes = ''
      this.$state.dimensions = {}
    },
    setShorts (shorts: TShortPage[]) {
      this.$state.shorts = shorts
    },
    setShortDimensions (translateX: string, translateY: string, width: string, height: string) {
      this.$state.dimensions.translateX = translateX
      this.$state.dimensions.translateY = translateY
      this.$state.dimensions.width = width
      this.$state.dimensions.height = height
    },
    setCurrentShort (slugId: string) {
      this.$state.slugId = slugId
    }
  },
  getters: {
    getCurrentShort: state => state.slugId
  }
})
